import { gql } from '@apollo/client';

const SAVE_SENT_FAX = gql`
  mutation SaveSentFax(
    $recipient: String!
    $faxNumber: String!
    $message: String!
    $details: String
    $status: String
    $attachments: [String!]!
  ) {
    save_sent_fax(
      recipient: $recipient
      fax_number: $faxNumber
      message: $message
      details: $details
      status: $status
      attachments: $attachments
    ) {
      id
      recipient
      fax_number
      message
      details
      attachment_names
      status
      sent_at
      created_at
    }
  }
`;

const SEND_SENT_FAX = gql`
  mutation SendSentFax($sentFaxId: ID!) {
    send_sent_fax(sent_fax_id: $sentFaxId) {
      id
      status
      provider_fax_id
      source
      sent_at
      completed_at
    }
  }
`;

const REFRESH_SENT_FAX_STATUS = gql`
  mutation RefreshSentFaxStatus($sentFaxId: ID!) {
    refresh_sent_fax_status(sent_fax_id: $sentFaxId) {
      id
      status
      provider_fax_id
      source
      sent_at
      completed_at
    }
  }
`;

export { SAVE_SENT_FAX, SEND_SENT_FAX, REFRESH_SENT_FAX_STATUS };
